import { render, staticRenderFns } from "./YearDropdown.vue?vue&type=template&id=3470e132&scoped=true"
import script from "./YearDropdown.vue?vue&type=script&lang=js"
export * from "./YearDropdown.vue?vue&type=script&lang=js"
import style0 from "./YearDropdown.vue?vue&type=style&index=0&id=3470e132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3470e132",
  null
  
)

export default component.exports